import React, { useEffect, useState } from 'react';
import { Select, TextField, Button, MenuItem, CircularProgress } from '@mui/material';
import * as themeService from "../../../services/ThemeService";
import * as tenyZarainaService from "../../../services/TenyZarainaService";
import logo from '../../../assets/imgs/logo.png';
import { useNavigate } from 'react-router-dom';
import "./addTenyZaraina.scss";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import BackButton from './../../../components/BackButton/BackButton';

const AddTenyZaraina = () => {
  const [title, setTitle] = useState('');
  const [contenu, setContenu] = useState('');
  const [vavaka, setVavaka] = useState('');
  const [file, setFile] = useState(null);
  const [theme, setTheme] = useState([]);
  const [options, setOptions] = useState(null);
  const [audio, setAudio] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    themeService.getAllTheme()
    .then(themes => {  
      setTheme(themes)
    });
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
  
    setIsLoading(true);
    
    const formData = new FormData();
    formData.append('title', title);
    formData.append('contenu', contenu);
    formData.append('vavaka', vavaka);
    formData.append('file', file);
  
    // Vérifiez si options est non vide avant d'essayer de l'utiliser
    if (options !== null) {
      formData.append('themeId', parseInt(options.split('/')[1]));
    } else {
      formData.append('themeId', null); // Si options est null, themeId sera null
    }
  
    formData.append('audio', audio);
  
    tenyZarainaService.addTenyZaraina(formData)
      .then((res) => {
        if (res.status === 200) {
          toast.success("Teny zaraina créé!", "Création de joke avec succès", "success");
          setTimeout(() => {
            navigate('/tenyzaraina');
          }, 5000);
        } else {
          toast.error("Nope", "Une erreur s'est produite", "error");
        }
      })
      .catch((err) => {
        toast.error("Nope", "Une erreur s'est produite", "error");
      });
  }  

  return (
    <div className="addTeny">
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <div className="back" >
        <BackButton />
      </div>
      <div className="contain-teny">
        <div className="formTeny">
          <form onSubmit={handleSubmit} >
            <p className='titre'>Création teny zaraina</p>
            <div className="tenyZ">
              <label className='label-tenyZ' >Lohateny</label>
              <TextField 
                label="Lohateny"
                variant="outlined"
                multiline
                maxRows={1000}
                type='text'
                value={title}
                onChange={(e)=> setTitle(e.target.value)}
                required
              />
            </div>
            <div className="tenyZ">
              <label className='label-tenyZ' >Famakafakana</label>
              <TextField 
                label="Contenu"
                variant="outlined"
                multiline
                maxRows={1000}
                type='text'
                value={contenu}
                onChange={(e)=> setContenu(e.target.value)}
                required
              />
            </div>
            <div className="tenyZ">
              <label className='label-tenyZ'>Vavaka</label>
              <TextField 
                label="Vavaka"
                variant="outlined"
                multiline
                maxRows={1000}
                type='text'
                value={vavaka}
                required
                onChange={(e)=>setVavaka (e.target.value)}
              />
            </div>
            <div className="selection-theme">
              <label className='label-tenyZ'>Loha-hevitra</label>
              <Select
                value={options || null} // Utilisation de l'option vide si options est null
                onChange={(e) => setOptions(e.target.value)}
                label="Loha-hevitra"
              >
                {Array.isArray(theme) && theme.length > 0
                  ? theme.map((themes) => (
                    <MenuItem key={themes.id} value={themes.nomTheme + '/' + themes.id}>
                      {themes.nomTheme}
                    </MenuItem>
                  ))
                  : null // Retirez le MenuItem pour "Aucun thème"
                }
              </Select>
            </div>
            <div className="dowload">
              <Button component="label" variant="contained" margin='normal' style={{background:'#bf9e1d', margin: '10px 15px',padding: '10px 25px'}}>
                Ajouter une photo ou vidéo
                <input hidden 
                  type="file" 
                  onChange={(e) => {setFile(e.target.files[0])}} 
                  accept="image/png, image/jpeg, video/mp4, image/jpg, image/PNG, image/gif"
                  required
                />
              </Button>
              <Button component="label" variant="contained" margin='normal' style={{background:'#bf9e1d', margin: '10px 15px',padding: '10px 25px'}}>
                Ajouter une audio
                <input hidden 
                  type="file" 
                  onChange={(e) => setAudio(e.target.files[0])} 
                  accept="audio/mp3"
                  />
              </Button>
            </div>
            <Button variant="contained" type='submit' margin='normal' disabled={isLoading} style={{background:'#2b2b81', marginTop:'10px'}}>
              {isLoading ? <CircularProgress size={24}/> : "Valider"}
            </Button>
          </form>
        </div>
      
        {/* Aperçu */}
        <div className="apercu-teny">
          <div className="entete">
            <img src={logo} alt="logo" />
            <div className="date">
              <span className="title">Teny Zaraina</span>
              <span className="date-publication">A l'instant</span>
            </div>
          </div>
          <div className="teny">
            <p>{title}</p>
            <p>{contenu}</p>
            {vavaka ? <p><strong>VAVAKA:</strong> {vavaka}</p> : null}
            {file && <div>
              {!file.type.includes('mp4') ? (
                <img src={URL.createObjectURL(file)} alt="Preview" />
              ) : 
                <video width="500" height="500" autoPlay controls>
                  <source src={URL.createObjectURL(file)} type="video/mp4" />
                </video>
              }
            </div>}
            <div className="audio-container">
              {audio && (
              <audio className="image-preview" controls>
                <source src={URL.createObjectURL(audio)} type='audio/mp3' />
              </audio>
              )}
            </div>
          </div>
          <div className="theme-teny">
            <p>{options !== null ? options.split('/')[0] : ''}</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AddTenyZaraina;